export const hindiConstants = {
  "general.error.chooseFile.size": "अधिकतम फ़ाइल आकार 12MB है",
  "dashboard.progress.label": "अनुपालन",
  "alert.msg.department.attribute": "विभाग गुण सफलतापूर्वक सहेजे गए हैं",
  "accept.prompt.proceed.yesno": "क्या आप जारी रखना चाहते हैं ?",
  "alert.msg.discard.feedback.failed": "फीडबैक त्यागना विफल रहा",
  "general.closeFeedbackFailure.level": "फीडबैक बंद करना विफल रहा",
  "alert.msg.discard.feedback.success": "प्रतिक्रिया खारिज कर दी गई",
  "general.notification.body": "प्रतिक्रिया के लिए सहमति आवश्यक",
  "general.date.duration.postfix": "पहले",
  "msg.login.page.first.heading": "आपकी प्रतिक्रिया, ",
  "msg.login.page.sec.heading": " हमारा समर्थन!",
  "msg.login.page.description":
    "फीडबैक जीवन के विभिन्न पहलुओं में सुधार, विकास, नवाचार और उत्कृष्टता को बढ़ावा देने के लिए उत्प्रेरक के रूप में कार्य करता है, चाहे वह व्यक्तिगत प्रदर्शन हो, टीम वर्क हो, या उत्पादों और सेवाओं की गुणवत्ता हो।",
  "general.tab.master.text": "मास्टर",
  "general.tab.attribute.text": "विशेषता",
  "general.tab.department.text": "विभाग",
  "general.tab.feedbackSource.text": "फ़ीडबैक स्रोत",
  "general.lable.attributeDetail.text": "विशेषता विस्तार देखें",
  "general.lable.departmentDetail.text": "विभाग विस्तार देखें",
  "general.lable.feedbackSourceDetail.text": "फ़ीडबैक स्रोत विस्तार देखें",
  "label.new.attributelist.SLNo": "क्रमांक",
  "label.new.attributelist.id": "विशेषता आईडी",
  "label.new.attributelist.name": "विशेषता विवरण",
  "label.new.attributelist.type": "विशेषता प्रकार",
  "label.new.attributelist.domain": "विशेषता डोमेन",
  "label.new.attributelist.action": "कार्य",
  "label.new.addAttribute": "विशेषता जोड़ें",
  "label.new.departmentlist.SLNo": "क्रमांक",
  "label.new.departmentlist.id": "विभाग आईडी",
  "label.new.departmentlist.name": "विभाग विवरण",
  "label.new.departmentlist.code": "विभाग कोड",
  "label.new.departmentlist.type": "विभाग प्रकार",
  "label.new.addDepartment": "विभाग जोड़ें",
  "label.new.editDepartment": "विभाग एडिट करें",
  "label.new.addFeedbackSource": "फ़ीडबैक स्रोत जोड़ें",
  "label.new.feedbackSource.id": "फ़ीडबैक स्रोत आईडी",
  "label.new.feedbackSource.description": "फ़ीडबैक स्रोत विवरण",
  "label.new.editFeedbackSource": "फ़ीडबैक स्रोत एडिट करें",
  "label.new.action.edit": "एडिट",
  "label.new.action.deactive": "निष्क्रिय",
  "label.new.editAttribute": "विशेषता एडिट करें",
  "label.new.update": "अपडेट",
  "label.new.save": "सेव",
  "label.new.deactiveConfirm": "क्या आप वाकई इसे निष्क्रिय करना चाहते हैं?",
  "label.new.editSuccessful": "संपादन सफल",
  "label.new.deactiveSuccessful": "निष्क्रियता सफल",
  "label.new.addSuccessful": "सम्मिलन सफल",
  "label.pleaseSelectValue": "कृपया एक मूल्य का चयन करें!",
  "label.fieldCannotBeEmpty": "क्षेत्र खाली नहीं छोड़ा जा सकता",
  "label.alphabetsOnly": "केवल अक्षर",
  "label.alphabetsAndUnderscoreOnly": "केवल अक्षर तथा अंडरस्कोर (_)",
  "label.valueAlreadyExists": "मूल्य पहले से मौजूद है",
  "msg.prop.project.name": "तुरंत उपाय",
  "login.welcome.msg": "हैलो उपयोगकर्ता!",
  "login.page.title.welcome": "|| आपका स्वागत है ||",
  "login.askForLogIn.msg": "कृपया अपना खाता एक्सेस करने के लिए लॉगिन करें",
  "general.label.email": "ईमेल आईडी",
  "general.placeHolder.email": "ईमेल आईडी दर्ज करें",
  "general.label.password": "पासवर्ड",
  "general.placeHolder.password": "पासवर्ड दर्ज करें",
  "general.label.captcha": "कैप्चा कोड",
  "general.placeHolder.captcha": "कैप्चा कोड दर्ज करें",
  "login.msg.failed": "आपका लॉगिन प्रयास सफल नहीं हुआ, फिर से प्रयास करें।",
  "login.msg.reason": "कारण",
  "login.msg.comment": "टिप्पणी",
  "general.label.signin": "लॉग इन करें",
  "general.label.signup": "रजिस्टर करें",
  "login.msg.notSignUp": "रजिस्टर नहीं है?",
  "general.label.fromDate": "दिनांक से",
  "general.label.clear.all": "",
  "general.placeHolder.fromDate": "कृपया फ्रॉम डेट यहां दर्ज करें",
  "general.label.toDate": "दिनांक तक",
  "general.placeHolder.toDate": "कृपया तो डेट यहां दर्ज करें",
  "customer.emailId.empty": "ईमेल आईडी दर्ज करें",
  "customer.mobileNumber.empty": "फोन नंबर दर्ज करें",
  "customer.organizationName.empty": "संगठन नाम दर्ज करें",
  "customer.firstName.empty": "प्रथम नाम दर्ज करें",
  "customer.lastName.empty": "अंतिम नाम दर्ज करो",
  "customer.description.empty": "फ़ीडबैक विवरण दर्ज करें",
  "customer.emailId.pattern.missmatch": "अमान्य ईमेल आईडी",
  "menu.key.navigation": "पथ प्रदर्शन",
  "menu.key.components": "अवयव",
  "menu.key.dashboard": "डैशबोर्ड",
  "menu.key.master": "मास्टर",
  "menu.key.master.department": "विभाग",
  "menu.key.master.attribute": "विशेषता",
  "menu.key.master.feedbackSource": "फीडबैक सोर्स",
  "menu.key.master.addGroup": "समूह जोड़ें",
  "menu.key.master.escMatrix": "वृद्धि मैट्रिक्स कॉन्फ़िगर करें",
  "menu.key.master.group.name": "समूह नाम",
  "menu.key.feedback": "फ़ीडबैक",
  "general.lable.untag.reason": "कृपया अपना कारण जोड़ें",
  "general.label.feedback.satisfaction":
    "अपनी संतुष्टिपूर्ण प्रतिक्रिया प्रस्तुत करने के लिए धन्यवाद",
  "menu.key.feedback.add": "फ़ीडबैक बनाएं",
  "menu.key.report": "रिपोर्ट",
  "menu.key.report.vsd": "वी एस डी रिपोर्ट",
  "menu.key.report.topnpercent": "शीर्ष प्रतिशत रिपोर्ट",
  "menu.key.report.branchreport": "शाखा रिपोर्ट",
  "menu.key.report.aging": "एजिंग रिपोर्ट",
  "menu.key.report.mis": "एमआईएस रिपोर्ट",
  "menu.key.report.misrawdump.multi.dept": "एमआईएस मल्टी विभाग रिपोर्ट",
  "menu.key.receipt.add": "रसीद बनाएं",
  "menu.key.feedback.reassignment": "फ़ीडबैक पुन:असाइनमेंट",
  "menu.key.feedback.close": "फ़ीडबैक बंद करें",
  "menu.key.feedback.close.multiple": "फीडबैक बंद करें",
  "menu.key.feedback.search": "फ़ीडबैक खोजे",
  "menu.key.feedback.accept": "फ़ीडबैक स्वीकार करें",
  "menu.key.feedback.view": "फ़ीडबैक देखें",
  "menu.key.feedback.quicklog": "फीडबैक क्विकलोग",
  "menu.key.feedback.reopen": "फिर से खुला फ़ीडबैक",
  "menu.key.feedback.close.bulkclosure": "फीडबैक का थोक समापन",
  "menu.key.rule.add": "नियम बनाएं",
  "menu.key.user": "उपयोगकर्ता",
  "menu.key.user.add": "उपयोगकर्ता बनाइये",
  "menu.key.user.add.internal" : "आंतरिक उपयोगकर्ता जोड़ें",
"menu.key.user.add.external" : "बाहरी उपयोगकर्ता जोड़ें",
  "menu.key.user.assigneeGropu": "समनुदेशिती समूह देखें",
  "menu.key.user.assigneegroup": "समनुदेशिती समूह",
  "menu.key.authorization.define": "प्राधिकरण अनुदान",
  "menu.key.configuration": "कॉन्फ़िगरेशन",
  "menu.key.escalation.matrix": "एस्केलेशन मैट्रिक्स",
  "menu.key.assigneeGrp.header": "समूह सूची",
  "menu.key.master.area": "मुख्य क्षेत्र",
  "menu.key.sub.area": "उप क्षेत्र",
  "menu.key.quickLog": "त्वरित अंक लॉग",
  "menu.key.callback": "कोल्बक",
  "menu.key.callback.report": "कोल्बक प्रतिवेदन",
  "menu.key.master.targettime": "लक्षित समय (DD-MM-YYYY HH:MM)",
  "menu.key.dashboard.list.targettime": "लक्षित समय",
  "menu.key.dashboard.list.organisation.name": "संगठन का नाम",
  "title.new.feedbacklist.viewFeedback": "फ़ीडबैक सूची देखें",
  "feedback.viewFeedback.searchbar": "यहां तलाश करो...",
  "feedback.viewFeedback.rowsPerPage": "रति पृष्ठ पंक्तियाँ",
  "label.new.feedbacklist.feedbackCdoe": "फीडबैक कोड",
  "label.new.feedbacklist.Description": "विवरण",
  "label.new.feedbacklist.Organization": "संगठन",
  "label.new.feedbacklist.DateOfFeedback": "फ़ीडबैक की तारीख",
  "label.new.feedbacklist.Status": "स्टेटस",
  "label.new.feedbacklist.Action": "कार्य",
  "label.new.feedbacklist.SLNo": "क्रमांक",
  "label.new.feedbacklist.select": "एकाधिक का चयन करें",
  "LdapAuthenticationProvider.badCredentials":
    "दर्ज उपयोगकर्ता  नाम/पासवर्ड गलत है",
  "AbstractUserDetailsAuthenticationProvider.badCredentials":
    "आपके द्वारा प्रदान किए गए क्रेडेंशियल्स अमान्य/लॉक/अवधि समाप्त  हैं",
  "AbstractUserDetailsAuthenticationProvider.internalAuthenticationServiceException.other":
    "अवैध उपयोगकर्ता-आईडी / पासवर्ड मिला, कृपया जाँच करें",
  "AbstractUserDetailsAuthenticationProvider.internalAuthenticationServiceException.exceededAllowed":
    "एक उपयोगकर्ता  का एक समय में केवल १ सेशन हो सकता है",
  "PasswordComparisonAuthenticator.badCredentials": "गलत पासवर्ड",
  "ConcurrentSessionControlAuthenticationStrategy.exceededAllowed":
    "एक उपयोगकर्ता  का एक समय में केवल १ सेशन हो सकता है",
  "error.captcha.blank": "कैप्चा खाली है",
  "error.captcha.invalid": "गलत कैप्चा",
  "label.general.navigation.youAreHere": "आप यहाँ हैं",
  "label.general.navigation.home": "होम",
  "label.addUser.page.title": "नया उपयोगकर्ता बनाएं",
  "label.addUser.pageHeader": "उपयोगकर्ता बनाइये",
  "label.addUser.navigation.User": "उपयोगकर्ता",
  "label.addUser.panelHeader": "नए उपयोगकर्ता की जानकारी प्रदान करें",
  "label.addUser.userForm.field.fullName.label": "पूरा नाम",
  "label.addUser.message.success": "उपयोगकर्ता सफलतापूर्वक बनाया गया ।",
  "label.addUser.message.fail":
    "आंतरिक त्रुटि के कारण उपयोगकर्ता नहीं बनाया गया !",
  "label.addUser.message.invalidInput":
    "उपलब्ध उपयोगकर्ता जानकारी वैध नहीं है।",
  "general.field.firstName.label": "पहला नाम",
  "general.field.firstName.placeHolder": "पहला नाम यहाँ दर्ज करें",
  "general.field.firstName.validation.notEmpty":
    "उपयोगकर्ता के लिए पहला नाम खाली नहीं होना चाहिए",
  "general.field.lastName.label": "अंतिम नाम",
  "general.field.lastName.placeHolder": "अंतिम नाम यहाँ दर्ज करें",
  "general.field.lastName.validation.notEmpty":
    "उपयोगकर्ता के लिए अंतिम नाम खाली नहीं होना चाहिए",
  "general.field.email.label": "ई-मेल एड्रेस",
  "general.field.email.placeHolder": "ईमेल यहां दर्ज करें",
  "general.field.email.validation.notEmpty":
    "ईमेल अनिवार्य है और खाली नहीं हो सकता",
  "general.field.email.validation.invalidEmail": "ईमेल आईडी मान्य नहीं है",
  "general.field.email.validation.mjEmail":
    "उपयोगकर्ता बनाने के लिए एमजंक्शन(mjunction) ईमेल का उपयोग नहीं किया जा सकता",
  "general.field.email.validation.alreadyExistEmail":
    "सीसीएचपी डेटा बेस में उपयोगकर्ता पहले से मौजूद है",
  "general.field.password.label": "पासवर्ड",
  "general.field.password.placeHolder": "यहां पासवर्ड दर्ज करें",
  "general.field.password.hint.text":
    "कम से कम एक अंक और एक वर्णमाला के छोटे और एक वर्णमाला के ऊपरी और एक वर्णमाला के चेहरे और एक विशेष अंक और ए",
  "general.field.password.validation.notEmpty":
    "पासवर्ड अनिवार्य है और रिक्त नहीं हो सकता",
  "general.field.password.validation.invalidPassword":
    "इनपुट पासवर्ड वैध नहीं है",
  "general.field.password.validation.limit.min":
    "पासवर्ड 8 वर्णों से अधिक लंबा होना चाहिए",
  "general.field.password.validation.limit.max":
    "पासवर्ड १५ वर्णों से अधिक लंबा नहीं होना चाहिए",
  "general.field.password.validation.charachter.lower":
    "पासवर्ड में कम से कम एक लोअर केस वर्ण होना चाहिए",
  "general.field.password.validation.charachter.upper":
    "पासवर्ड में कम से कम एक ऊपरी केस वर्ण होना चाहिए",
  "general.field.password.validation.charachter.digit":
    "पासवर्ड में कम से कम एक अंक होना चाहिए",
  "general.field.password.validation.charachter.special":
    "पासवर्ड में कम से कम एक विशेष वर्ण होना चाहिए '@#$%^+=' में से",
  "general.field.confirmPassword.label": "पासवर्ड फिर से लिखें",
  "general.field.confirmPassword.placeHolder":
    "कृपया फिर से पासवर्ड यहां टाइप करें",
  "general.field.confirmPassword.validation.notEmpty":
    "पासवर्ड की पुष्टि अनिवार्य है और रिक्त नहीं हो सकता",
  "general.field.confirmPassword.validation.identicalToPassword":
    "पासवर्ड और इसकी लिखित पुष्टिकरण समान नहीं है",
  "general.field.mobile.label": "मोबाइल नंबर",
  "general.field.mobile.placeHolder": "मोबाइल नंबर(९९९९९९९९९९) यहां दर्ज करें",
  "general.field.mobile.hint": "९९९९९९९९९९",
  "general.field.mobile.validation.notEmpty":
    "मोबाइल नंबर अनिवार्य है और खाली नहीं हो सकता",
  "general.field.mobile.validation.invalidMobile": "मोबाइल नंबर अमान्य है",
  "general.field.phone.label": "फ़ोन नंबर",
  "general.field.phone.placeHolder": "फ़ोन नंबर(८ तो १२ अंक) यहां दर्ज करें",
  "general.field.phone.hint": "८ तो १२ अंक",
  "general.field.phone.validation.notEmpty":
    "फोन नंबर अनिवार्य है और रिक्त नहीं हो सकता",
  "general.field.phone.validation.invalidPhone": "फ़ोन नंबर अमान्य है",
  "general.field.addressLine.label": "पता",
  "general.field.addressLine.placeHolder": "कृपया यहां पता लिखें",
  "general.field.addressLine.validation.notEmpty":
    "पता पंक्ति अनिवार्य है और रिक्त नहीं हो सकती",
  "general.field.addressLine.validation.sizeLimit.LT1000":
    "पता पंक्ति १000 वर्णों से कम लंबा होनी चाहिए",
  "general.message.checkInputBeforeSubmit":
    "सबमिट करने से पहले कृपया सभी जानकारी की जांच करें!",
  "general.message.checkInputBeforeDownload":
    "कृपया डाउनलोड करने से पहले सभी जानकारी ठीक से जांच लें",
  "general.message.errorFetchingData": "डेटा लाने के दौरान त्रुटि हुई!",
  "general.message.panel.heading.msg": "सूचना",
  "general.button.panel.footer.close": "बंद करे",
  "general.button.reset.label": "रीसेट",
  "general.button.submit.label": "जमा करें",
  "general.button.view.report.label": "रिपोर्ट देखें",
  "general.button.download.pdf.report.label": "पीडीऍफ़ डाउनलोड करें",
  "general.button.download.excel.report.label": "एक्सेल डाउनलोड करें",
  "general.tooltip.charachter.limit.remaining": "अक्षर अवशिष्ट है",
  "general.tooltip.charachter.limit.moreThan": "",
  "general.tooltip.charachter.limit.chUnacceptable":
    "से अधिक वर्ण अस्वीकार्य हैं",
  "general.message.select.label": "चुने",
  "general.message.notApplicable.label": "लागू नहीं",
  "label.defineAuthorization.page.title": "प्राधिकरण अनुदान",
  "label.defineAuthorization.pageHeader": "प्राधिकरण अनुदान",
  "label.defineAuthorization.navigation.authorization": "प्राधिकरण",
  "label.defineAuthorization.userListPanelHeader":
    "सूची से उपयोगकर्ता को चुनें",
  "label.defineAuthorization.panelHeader": "अनुदान प्राधिकरण",
  "label.defineAuthorization.selectRole.label": "रोल का चयन करें",
  "label.defineAuthorization.saveRoleConfPrefix.msg": "क्या आप वाकई",
  "label.defineAuthorization.saveRoleConfSufix.msg":
    "को निम्न भूमिका प्रदान करना चाहते हैं?",
  "label.defineAuthorization.saveRoleSuccess.msg":
    "उपयोगकर्ता को नामित भूमिका सफलतापूर्वक प्रदान की गई है।",
  "label.defineAuthorization.saveRoleFailure.msg":
    "कुछ आंतरिक त्रुटि के कारण उपयोगकर्ता को निर्दिष्ट भूमिका सफलतापूर्वक नहीं दी गई है।",
  "label.defineAuthorization.message.invalidInput":
    "उपयोक्ता की भूमिका जानकारी मान्य नहीं है।",
  "label.defineAuthorization.title.add-more-auth": "अधिक अधिकार दें",
  "label.defineAuthorization.title.remove-this-auth":
    "इस प्राधिकृत्य को हटा दें",
  "label.defineAuthorization.error.role.requered": "कृपया भूमिका चुनें",
  "label.defineAuthorization.error.department.requered": "कृपया विभाग चुनें",
  "label.defineAuthorization.error.duplicate.row.partOne": "आप पहले से ही",
  "label.defineAuthorization.error.duplicate.row.partTwo": "भूमिका  को",
  "label.defineAuthorization.error.duplicate.row.partThree":
    "विभाग के लिए  चुने हैं!",
  "general.datatable.sEmptyTable.label": "तालिका में कोई डेटा नहीं है",
  "general.datatable.sInfo.label":
    "_START_ से _END_ तक, कुल _TOTAL_ प्रविष्टियाँ दिखा रहे हैं",
  "general.datatable.sInfoEmpty.label": "0 से 0 से 0 प्रविष्टियाँ दिखा रहे हैं",
  "general.datatable.sInfoFiltered.label":
    "(_MAX_ कुल प्रविष्टियाँ में से छवियों द्वारा छाँटे गए)",
  "general.datatable.sInfoPostFix.label": "",
  "general.datatable.sInfoThousands.label": ",",
  "general.datatable.sLengthMenu.label": "_MENU_ प्रविष्टियाँ दिखाएं",
  "general.datatable.sLoadingRecords.label": "लोड हो रहा है...",
  "general.datatable.sProcessing.label": "प्रगति पे हैं...",
  "general.datatable.sSearch.label": "खोजें:",
  "general.datatable.sort.by": "क्रमबद्ध करें:",
  "general.closefeedbackEmpty.lebel":
    "कृपया बंद करने के लिए कम से कम एक फीडबैक चुनें",
  "general.closeFeedbackSuccess.level": "फीडबैक सफलतापूर्वक बंद हो गया",
  "general.datatable.sZeroRecords.label": "रिकॉर्ड्स का मेल नहीं मिला",
  "general.datatable.sFirst.label": "प्रथम",
  "general.datatable.sLast.label": "अंतिम",
  "general.datatable.sNext.label": "अगला",
  "general.datatable.sPrevious.label": "पिछला",
  "general.datatable.sSortAscending.label":
    ": activate to sort column ascending",
  "general.datatable.sSortDescending.label":
    ": activate to sort column descending",
  "general.button.yes.label": "हाँ",
  "general.button.no.label": "नहीं",
  "general.button.ok.label": "ठीक",
  "general.button.update.label": "उपयोगकर्ता को अद्यतन करें",
  "general.button.cancel.label": "रद्द करें",
  "user.role.admin.label": "व्यवस्थापक",
  "user.role.buHead.label": "बुउ हेड",
  "user.role.buManager.label": "बुउ प्रबंधक",
  "user.role.customerSupport.label": "ग्राहक सहेयता",
  "user.role.escalationMatrixUser.label": "वृद्धि मैट्रिक्स उपयोगकर्ता",
  "user.role.spoc.label": "एस पी ओ सी",
  "user.role.resolver.label": "रिज़ॉल्वर",
  "user.role.callCenterPersonnel.label": "कॉल सेंटर कार्मिक",
  "user.role.employee.label": "कर्मचारी",
  "user.role.customer.label": "ग्राहक",
  "user.role.vp.head.label": "वीपी/प्रमुख",
  "user.role.client.label": "क्लाइंट",
  "user.role.client2.label": "क्लाइंट २",
  "user.role.client3.label": "क्लाइंट ४",
  "user.department.select.label": "विभाग चुनें",
  "user.info.general.invalid.info.errMsg":
    "उपलब्ध उपयोगकर्ता जानकारी अमान्य पाया गया",
  "user.info.role.notFound.errMsg": "उपयोगकर्ता की भूमिका जानकारी नहीं मिली",
  "user.info.department.notFound.errMsg":
    "उपयोगकर्ता की विभाग जानकारी नहीं मिली",
  "general.msg.credential.undefined": "अपरिभाषित क्रेडेंशियल।",
  "general.msg.credential.changed.success":
    "पासवर्ड सफलतापूर्वक बदला गया। अपने नए पासवर्ड का उपयोग करके लॉग-इन करें।",
  "general.field.password.old.label": "पुराना पासवर्ड",
  "general.field.password.old.placeHolder":
    "कृपया अपना पुराना पासवर्ड यहां दर्ज करें",
  "general.field.password.old.validation.notEmpty":
    "पुराना पासवर्ड अनिवार्य है और रिक्त नहीं छोड़ा जा सकता।",
  "general.field.password.new.label": "नया पासवर्ड",
  "general.field.password.new.placeHolder":
    "कृपया अपना नया पासवर्ड यहां दर्ज करें",
  "general.field.password.new.validation.notEmpty":
    "नया पासवर्ड अनिवार्य है और रिक्त नहीं छोड़ा जा सकता।",
  "general.field.password.validation.sameAsOldPassword":
    "पुराने और नए दोनों पासवर्ड समान हैं",
  "general.field.password.validation.invalidOldPassword":
    "पुराने पासवर्ड गलत दर्ज किया गया",
  "page.reset.password.heading": "कृपया नीचे अपना पासवर्ड रीसेट करें",
  "page.reset.password.button.restpwd": "रीसेट पासवर्ड",
  "page.reset.password.buttom.msg":
    "***कृपया ध्यान दें, यदि आप यह पृष्ठ देख रहे हैं, तो इसका मतलब है कि आप पहली बार उपयोगकर्ता हैं या आपका पासवर्ड की समय सीमा समाप्त हो गया है!",
  "page.reset.password.error.internal":
    "कुछ आंतरिक त्रुटि के कारण पासवर्ड रीसेट विफल रहा, कृपया पुनः प्रयास करें!",
  "general.dialog.label.sessionExpired": "सेशन समाप्त",
  "general.dialog.title.sessionExpired": "सेशन शीघ्र ही समाप्त हो रहा है",
  "general.dialog.msg.sessionExpired": "आपका सेशन समाप्त होने वाला है।",
  "general.dialog.button.label.logoutNow": "अभी लॉगआउट करें",
  "general.dialog.button.label.stayConnected": "जुड़े रहें",
  "general.dialog.title.autoLogOut":
    "लॉगिन पेज पर रीडायरेक्ट किया जा रहा है ...",
  "general.dialog.title.multiSignDecision": "कृपया अपनी प्राथमिकता चुनें ...",
  "general.page.sessionExpired.msgH5":
    "आपका सत्र समाप्त हो गया है, 5 सेकंड में लॉगिन पेज पर पुनर्निर्देशित हो जाएगा ...",
  "report.page.aging.table.header.feedbacktype": "प्रतिक्रिया प्रकार",
  "report.page.aging.table.header.area": "मुख्य क्षेत्र",
  "report.page.aging.table.header.subarea": "उप क्षेत्र",
  "report.page.aging.table.header.priority": "प्राथमिकता",
  "report.page.rpt.table.header.loggersCompany": "रजिस्ट्रार की कंपनी",
  "report.page.aging.table.header.days": "दिन",
  "report.page.aging.table.header.grandTotal": "ग्रैंड टोटल",
  "report.aging.error.msg.date.minimum.bucketsize":
    "रिपोर्ट तिथि सीमा को कम से कम {0} दिन अंतर में होना चाहिए",
  "report.aging.error.msg.date.minimum.days":
    "रिपोर्ट तिथि सीमा को कम से कम {0} दिन अंतर में होना चाहिए",
  "report.aging.error.msg.date.maximum.days":
    "रिपोर्ट तिथि सीमा को ज्यादा से ज्यादा {0} दिन अंतर में होना चाहिए",
  "report.aging.warning.msg.date.minmax.days":
    "***दिनांक सीमा को न्यूनतम ३० और अधिकतम ९० दिन चुना जाना चाहिए",
  "report.aging.error.msg.noRecords":
    "दिए गए मानदंडों के लिए कोई रिकॉर्ड नहीं मिला।",
  "report.aging.error.msg.general":
    "रिपोर्ट की पीढ़ी के दौरान त्रुटि हुई। कृपया अपने दिए गए इनपुट चेक करें या सिस्टम व्यवस्थापक से संपर्क करें।",
  "report.aging.error.department.requered": "कृपया विभाग का चयन करें",
  "report.aging.error.fromDate.requered": "तिथि से आवश्यक है",
  "report.aging.error.fromDate.invalid": "फ्रॉम डेट मान्य नहीं है",
  "report.aging.error.endDateLessThanStartDate":
    "कृपया सुनिश्चित करें कि प्रारंभ दिनांक समाप्ति दिनांक के बाद है।",
  "report.aging.error.toDate.requered": "तो डेट आवश्यक है",
  "report.aging.error.toDate.invalid": "तो डेट मान्य नहीं है",
  "report.aging.error.reportType.requered": "वांछित रिपोर्ट प्रकार चुनें",
  "report.aging.page.header.from.details": "एजिंग विवरण",
  "report.aging.label.selectReportType": "रिपोर्ट प्रकार चुनें",
  "report.aging.reportType.msg.RegisteredANDAssignedToGroup":
    "रजिस्टर्ड - एसाइन्ड टू ग्रुप",
  "report.aging.reportType.msg.AssignedToGroupANDPickedUp":
    "एसाइन्ड टू ग्रुप - ओपन",
  "report.aging.reportType.msg.PickedUpANDResolve": "ओपन - रेसॉल्व",
  "report.aging.reportType.msg.ResolvedANDClose": "रेसॉल्व्ड - क्लोज",
  "report.aging.helpText.msg.RegisteredANDAssignedToGroup":
    '***रिपोर्ट प्रकार "रजिस्टर्ड - एसाइन्ड टू ग्रुप" के लिए चयनित फीडबैक प्रदान की गई दिनांक सीमा १६ और ९६ दिनों के बीच होनी चाहिए',
  "report.aging.helpText.msg.AssignedToGroupANDPickedUp":
    '***रिपोर्ट प्रकार "एसाइन्ड टू ग्रुप - ओपन" के लिए चयनित फीडबैक प्रदान की गई दिनांक सीमा १ और ९ दिनों के बीच होनी चाहिए',
  "report.aging.helpText.msg.PickedUpANDResolve":
    '***रिपोर्ट प्रकार "ओपन - रेसॉल्व" के लिए चयनित फीडबैक प्रदान की गई दिनांक सीमा ९ और ६ दिनों के बीच होनी चाहिए',
  "report.aging.helpText.msg.ResolvedANDClose":
    '***रिपोर्ट प्रकार "रेसॉल्व्ड - क्लोज" के लिए चयनित फीडबैक प्रदान की गई दिनांक सीमा ९ और ६ दिनों के बीच होनी चाहिए',
  "report.mis.page.header.from.details": "एमआईएस विवरण",
  "report.mis.label.selectMonth": "महीना चुनिए",
  "report.type.label.misMonthly": "शिकायत प्रबंधन डैशबोर्ड",
  "report.type.label.misTopReasons": "शीर्ष कारण",
  "report.type.label.misTopRepeatReasons": "शीर्ष दोहराया गया कारण",
  "report.type.label.misVOC": "ग्राहक आवाजविना",
  "report.type.label.repeatPercentage": "रिपीट प्रतिशत",
  "report.type.label.rawDump": "सीसीईपीटी एमैआईएस",
  "report.mis.label.combined": "संयुक्त",
  "report.mis.warning.msg.date.minmax.days":
    "***शिकायत प्रबंधन डैशबोर्ड रिपोर्टके लिए दिनांक सीमा १६ और ९६ दिनों के बीच होनी चाहिए",
  "report.mis.rawDump.warning.msg.date.minmax.days":
    "***सीसीईपीटी एमैआईएस रिपोर्टके लिए दिनांक सीमा १ और ९ दिनों के बीच होनी चाहिए",
  "report.mis.multi.dept.error.department.required": "कम से कम एक विभाग चुनें",
  "report.mis.multi.dept.error.invalid.dates": "कृपया मान्य तिथि प्रदान करें",
  "report.mis.multi.dept.error.from.before.to":
    "प्रारंभ तिथि, समाप्ति तिथि से कम से कम १ दिन पहले होनी चाहिए",
  "report.mis.multi.dept.error.download.failed": "एमआईएस मल्टी विभाग रिपोर्ट डाउनलोड विफल",
  "report.mis.multi.dept.label.isResolved": "समाधानित",
  "report.mis.multi.dept.isResolved.all": "सभी",
  "report.mis.multi.dept.isResolved.yes": "समाधानित",
  "report.mis.multi.dept.isResolved.no": "असमाधानित",
  "report.mis.column.label.raised": "उठाया गया",
  "report.mis.column.label.openWithinSla": "एसएलए के भीतर ओपन",
  "report.mis.column.label.openOutOfSla": "एसएलए के बाहर ओपन",
  "report.mis.column.label.openWithCSWithinSla": "एसएलए के भीतर साथ के साथ ओपन",
  "report.mis.column.label.openWithCSOutOfSla": "एसएलए के बाहर साथ के साथ ओपन",
  "report.mis.column.label.totalClosed": "कुल क्लोज",
  "report.mis.column.label.closedWithinSla": "स्लै के अंदर बंद",
  "report.mis.column.label.closedOutOfSla": "स्लै के बाहर बंद",
  "report.mis.column.label.reopenedWithBUWithinSla":
    "एसएलए के भीतर बीयू के साथ पुनः खोला गया",
  "report.mis.column.label.reopenedWithBUOutOfSla":
    "एसएलए के बाहर बीयू के साथ पुनः खोला गया",
  "report.mis.column.label.reopenedWithCSWithinSla":
    "एसएलए के भीतर साथ के साथ पुनः खोला गया",
  "report.mis.column.label.reopenedWithCSOutOfSla":
    "एसएलए के बाहर साथ के साथ पुनः खोला गया",
  "report.mis.column.label.totalReopenedAndClosed":
    "कुल पुनः खोला और बंद हो गया",
  "report.mis.column.label.reopenedAndClosedWithinSla":
    "एसएलए के भीतर पुनः खोला और बंद हो गया",
  "report.mis.column.label.reopenedAndClosedOutOfSla":
    "एसएलए के बाहर पुनः खोला और बंद हो गया",
  "report.mis.column.label.slaPercentage": "एसएलए%",
  "report.mis.column.label.contributionOnTotalVolPercent":
    "कुल मात्रा का योगदान%",
  "report.mis.label.reportMonths": "रिपोर्ट महीने",
  "report.mis.label.months": "महीने",
  "report.mis.placeHolder.reportMonths": "रिपोर्ट महीने चुनें",
  "report.mis.error.reportMonths.requered": "रिपोर्ट महीने आवश्यक हैं",
  "report.mis.error.reportMonths.2to3Options":
    "कृपया एक से अधिक रिपोर्ट महीने चुनें",
  "report.mis.error.reportMonths.consecutive":
    "कृपया रिपोर्ट महीने को लगातार कार्य करने के लिए लॉगिन करें",
  "report.mis.column.label.notSatisfiedPercentage": "असंतुष्टि%",
  "report.mis.column.label.repeatPercentage.fType.complaints": "शिकायतें",
  "report.mis.column.label.repeatPercentage.fType.rest":
    "आराम (शिकायतों के अलावा)",
  "report.mis.column.label.repeatPercentage.fType.overall": "समग्र",
  "report.mis.column.label.repeatPercentage.months.totalPeriod":
    "कुल (वर्तमान अवधि + पिछला समान अवधि)",
  "report.mis.column.label.repeatPercentage.months.repeats":
    "दोहराए (वर्तमान अवधि + पिछला समान अवधि)",
  "report.mis.column.label.repeatPercentage.months.repeatPeriod":
    "एक विशिष्ट ग्राहक के खिलाफ एक से अधिक सीसीएचपी टैग के साथ सीसीएचपी टैग की संख्या के साथ पुनः खोले जाने पर फिर से खुलने का प्रतिशत (उदाहरण के लिए रोलिंग {0} दिन = {1} वर्तमान अवधि के {2} दिन + पिछले समान अवधि के {3} दिन)",
  "report.mis.column.label.repeatPercentage.months.total": "कुल",
  "report.mis.column.label.rawDump.bu": "व्यापारिक इकाइयां",
  "report.mis.column.label.rawDump.feedbackDate": "प्रतिक्रिया तिथि",
  "report.mis.column.label.rawDump.spocName": "स्पॉक का नाम",
  "report.mis.column.label.rawDump.feedbackAssignmentTime":
    "प्रतिक्रिया असाइनमेंट समय",
  "report.mis.column.label.rawDump.assignmentDuration": "असाइनमेंट अवधि",
  "report.mis.column.label.rawDump.loggerName": "लॉगर का नाम",
  "report.mis.column.label.rawDump.vendorcode": "विक्रेता कोड",
  "report.mis.column.label.rawDump.loggerMobile": "लॉगर मोबाइल",
  "report.mis.column.label.rawDump.loggerPhone": "लॉगर फ़ोन",
  "report.mis.column.label.rawDump.loggerType": "लॉगर प्रकार",
  "report.mis.column.label.rawDump.loggerId": "लॉगर आईडी",
  "report.mis.column.label.rawDump.feedbackCreatorName":
    "प्रतिक्रिया निर्माता का नाम",
  "report.mis.column.label.rawDump.pickedUpTime": "पिकअप समय",
  "report.mis.column.label.rawDump.pickedUpDuration": "पिकअप अवधि",
  "report.mis.column.label.rawDump.resolutionDate": "रिज़ॉल्यूशन तिथि",
  "report.mis.column.label.rawDump.resolverRemarks": "रिज़ॉल्यूशन टिप्पणियाँ",
  "report.mis.column.label.rawDump.escalatedToFirstLevel":
    "पहले स्तर पर उच्चतम",
  "report.mis.column.label.rawDump.firstLevelEscalationTime":
    "पहले स्तर की ऊर्जा का समय",
  "report.mis.column.label.rawDump.escalatedToSecondLevel":
    "दूसरे स्तर पर बढ़ाया गया",
  "report.mis.column.label.rawDump.secondLevelEscalationTime":
    "दूसरे स्तर की ऊर्जा का समय",
  "report.mis.column.label.rawDump.escalatedToThirdLevel":
    "तीसरे स्तर पर बढ़ाया गया",
  "report.mis.column.label.rawDump.thirdLevelEscalationTime":
    "तीसरे स्तर की ऊर्जा का समय",
  "report.mis.column.label.rawDump.assignmentEscalationStatus":
    "असाइनमेंट ऊर्जा स्थिति",
  "report.mis.column.label.rawDump.pickupEscalationStatus":
    "पिकअप ऊर्जा स्थिति",
  "report.mis.column.label.rawDump.closureEscalationStatus":
    "क्लोज़र ऊर्जा स्थिति",
  "report.mis.column.label.rawDump.sLADuration24By7Frame":
    "एसएलए अवधि (24/7 फ़्रेम)",
  "report.mis.column.label.rawDump.feedbackPendingWith": "प्रतिक्रिया लंबित है",
  "report.mis.column.label.rawDump.customerConsentComment":
    "ग्राहक सहमति टिप्पणी",
  "report.mis.column.label.rawDump.closingDate": "क्लोज़िंग तिथि",
  "report.mis.column.label.rawDump.isEscalatedFeedback": "बढ़ाया गया है",
  "report.mis.column.label.rawDump.firstEscalationDate": "पहले ऊर्जा तिथि",
  "report.mis.column.label.rawDump.assignmentTarget": "असाइनमेंट लक्ष्य",
  "report.mis.column.label.rawDump.pickupTarget": "पिकअप लक्ष्य",
  "report.mis.column.label.rawDump.closureTarget": "क्लोजर लक्ष्य",
  "general.label.status.new": "नया",
  "general.label.status.unassigned": "असाइन नहीं किया गया",
  "general.label.status.assign": "असाइन",
  "general.label.status.assigned": "एसाइन्ड",
  "general.label.status.open": "ओपन",
  "general.label.status.opened": "ओपेनेड",
  "general.label.status.reopen": "रीओपन",
  "general.label.status.reopened": "रेओपेनेड",
  "general.label.status.resolve": "रिज़ॉल्व",
  "general.label.status.resolved": "रिज़ॉल्व्ड",
  "general.label.status.close": "क्लोज",
  "general.label.status.closed": "क्लोज्ड",
  "general.label.status.atg": "एसाइन्ड तो ग्रुप",
  "general.label.total": "कुल",
  "general.label.quickIssueAcceptedFeedback1":
    "फीडबैक सफलतापूर्वक जोड़ दिया गया है",
  "general.label.quickIssueAcceptedFeedback2": "कृपया फीडबैक कोड नोट कर लें ",
  "general.label.quickIssueAcceptedFeedback3": " आगे संचार के लिए",
  "general.button.filterMore.text": "अधिक फ़िल्टर",
  "general.button.filterLess.text": "कम फ़िल्टर",
  "general.label.feedbackStatus.text": "फ़ीडबैक स्थिति",
  "general.lable.select.feedbackStatus.text": "फ़ीडबैक स्थिति का चयन करें",
  "general.lable.feedbackType.text": "फ़ीडबैक प्रकार",
  "general.lable.select.feedbackType.text": "फ़ीडबैक प्रकार का चयन करें",
  "general.lable.select.masterArea.text": "मुख्य क्षेत्र का चयन करें",
  "general.lable.select.subArea.text": "उप क्षेत्र का चयन करें",
  "general.lable.select.feedbackSource.text": "फ़ीडबैक स्रोत का चयन करें",
  "general.lable.bidderOrg.text": "बोलीदाता संगठन",
  "general.lable.username.text": "उपयोगकर्ता नाम",
  "general.lable.bidderId.text": "बोलीदाता आईडी",
  "general.lable.panNo.text": "पैन नंबर",
  "general.lable.table.select.groupType.text": "समनुदेशिती समूह प्रकार",
  "general.mobileNumber.Mobile": "मोबाइल",
  "general.phoneNumber.Phone": "फ़ोन",
  "general.lable.vendorCode.text": "विक्रेता कोड",
  "general.button.view.text": "विस्तार",
  "general.button.edit.text": "संपादित करें",
  "general.button.search.text": "खोजें",
  "general.error.fromDate.required": "कृपया फ्रॉम डेट दर्ज करें",
  "general.error.toDate.required": "कृपया तो डेट दर्ज करें",
  "general.error.feedbackStatus.required": "कृपया फ़ीडबैक स्थिति का चयन करें",
  "general.error.fromDateNotGreater.required":
    "तो डेट से फ्रॉम डेट अधिक नहीं हो सकता",
  "general.msg.logout.text": "लॉग आउट",
  "general.lable.feedbackDetail.text": "फ़ीडबैक विस्तार",
  "general.tab.feedbackDetails.text": "फ़ीडबैक विवरण",
  "general.tab.assigneeGrp.details": "विवरण(जोड़ें/संपादित करें)",
  "general.tab.commentDetails.text": "टिप्पणी का विवरण",
  "general.tab.receiptDetails.text": "रसीद विवरण",
  "general.tab.resolutionDetails.text": "रिज़ॉल्यूशन विवरण",
  "general.tab.slaDetails.text": "एसएलए विवरण",
  "general.tab.customerSatisfaction.text": "ग्राहक संतुष्टि",
  "general.select.satisfactionReason.textForStar":
    "संतुष्टि स्तर (** रेटिंग 1 से 3 को संतुष्ट नहीं माना जाता है इसलिए टिप्पणी/कारण आवश्यक है)",
  "feedbackDetails.currentStatus.text": "वर्तमान स्थिति",
  "Feedback Details": "hjhgjfghfj",
  "feedbackDetails.organizationName.text": "संगठन का नाम",
  "general.label.dropdown.email": "ईमेल",
  "feedbackDetails.feedbackDescription.text": "फीडबैक विवरण",
  "general.model.lable.header.Area.subarea": "क्षेत्र :: उप क्षेत्र",
  "gereral.model.lable.header.responseLogger": "लकड़हारा को प्रतिक्रिया",
  "feedbackDetails.feedbackGiven.text": "द्वारा दिए गए फ़ीडबैक",
  "feedbackDetails.address.text": "पता",
  "feedbackDetails.createdBy.text": "के द्वारा बनाई गई",
  "feedbackDetails.taggedFeedbackList.text": "टैग की गई फ़ीडबैक विवरण",
  "feedbackDetails.receiver.text": "रिसीवर",
  "feedbackDetails.targetCompilationDate.text":
    "टारगेट हासिल करने की तारीख(DD-MM-YYYY HH:MM)",
  "feedbackDetails.actualCloseDate.text":
    "वास्तविक बंद हासिल(DD-MM-YYYY HH:MM)",
  "feedbackDetails.assignedTo.text": "को सौंपना",
  "feedbackDetails.comment.text": "टिप्पणी",
  "feedbackDetails.resolverName.text": "रिज़ॉलर का नाम",
  "feedbackDetails.rootCause.text": "मूल कारण",
  "feedbackDetails.correctiveAction.text": "सुधार करने हेतु कार्रवाई",
  "feedbackDetails.preventiveAction.text": "निवारक कार्रवाई",
  "feedbackDetails.responseToLogger.text": "ग्राहक के लिए प्रतिसाद",
  "feedbackDetails.completionDate.text": "समापन की तारीख",
  "feedbackDetails.autoClosureDate.text": "ऑटो क्लोजर तिथि",
  "feedbackDetails.reopenReason.text": "फिर से खोलें / असंतुष्ट कारण",
  "feedbackDetails.resolutionTarget.text": "रिज़ॉल्यूशन टारगेट",
  "feedbackDetails.step.text": "स्टेप",
  "feedbackDetails.assignName.text": "नियुक्ति नाम",
  "feedbackDetails.targetTime.text": "टारगेट समय",
  "feedbackDetails.escalationMatrix.text": "रिज़ॉल्यूशन एस्केलेशन मैट्रिक्स",
  "feedbackDetails.level.text": "स्तर",
  "feedbackDetails.groupName.text": "ग्रुप का नाम",
  "feedbackDetails.escalationTime.text": "एस्केलेशन समय",
  "feedbackDetails.feedbackCode.text": "फीडबैक कोड",
  "feedbackDetails.receiptView.text": "आप देख रहे हैं",
  "feedbackDetails.satisfactionView.text": "आप संतुष्टि स्तर देख रहे हैं",
  "feedbackDetails.commentView.text": "आप टिप्पणी दे रहे हैं",
  "feedbackDetails.reopenReassignView.text":
    "आप दोबारा खोलना और पुनः आवंटित कर रहे हैं",
  "feedbackDetails.slaView.text": "आप एसएलए देख रहे हैं",
  "general.lable.timeLine.text": "समय रेखा",
  "general.button.provideConsent.text": "सहमति प्रदान करें",
  "general.checkbox.addConsent.text": "सहमति जोड़ें",
  "general.lable.consentUser.text": "सहमति उपयोगकर्ता",
  "general.select.selectConsent.text": "सहमति चुनें",
  "general.lable.consent.text": "सहमति",
  "general.button.reopenReassign.text": "दोबारा फिर से खोलें",
  "general.lable.satisfactionLevel.text": "संतोष स्तर",
  "general.lable.unsatisfactionReason.text": "असंतोष का कारण",
  "general.lable.otherReason.text": "कोई अन्य कारण",
  "general.lable.otherComment.text": "अन्य टिप्पणी",
  "general.select.satisfactionLevel.text": "संतोष स्तर चुनें",
  "general.select.selectUser.text": "उपयोगकर्ता का चयन करें",
  "general.lable.userList.text": "उपयोगकर्ता विवरण",
  "general.error.comment.required": "अपनी टिप्पणी दर्ज करें",
  "general.error.consent.required": "आपकी सहमति यहां है...",
  "general.error.reason.required": "कारण / त्रुटि",
  "general.lable.monthOfFeedbackbk.text": "फ़ीडबैक का महीना और वर्ष",
  "general.lable.monthOfFeedback.text": "फ़ीडबैक का महीना और वर्ष",
  "general.lable.closeFeedbackDate.text": "फ़ीडबैक बंद तारीख",
  "general.lable.reopendFeedbackDate.text": "फिर से खोलने की तारीख",
  "general.lable.loggedOn.text": "लॉग किया",
  "general.lable.recentFeedbacks.text": "हाल के फीडबैक",
  "general.lable.myTasks.text": "हमारी प्रतिक्रिया को रेट करें",
  "general.lable.latestEvents.text": "नवीनतम घटनाओं",
  "general.lable.performanceChart.text": "प्रदर्शन चार्ट",
  "general.lable.avgResolutionTime.text": "औसत रिज़ॉल्यूशन समय",
  "general.button.searchMore.text": "और खोजें ...",
  "general.chart.legend.issueRaised": "उठाए गए फीडबैक की संख्या",
  "general.chart.legend.issueResolved": "फीडबैक की समाधान संख्या",
  "general.chart.area.defaultMessage": "अब दिखाने के लिए कुछ नहीं!",
  "general.chart.area.noTask": "अब कोई प्रतिक्रिया उपलब्ध नहीं है!",
  "general.chart.area.latestEvent":
    "कोई नया इवेंट / लॉयल्टी ऑफ़र अब उपलब्ध नहीं है!",
  "general.chart.legend.complaint": "अभियोग फीडबैक",
  "general.chart.legend.others": "अन्य फीडबैक",
  "general.chart.legend.other": "अन्य",
  "general.badge.registered": "रजिस्टर्ड",
  "general.badge.workInProgress": "वर्क इन प्रोग्रेस",
  "general.lable.status.showAll": "सब दिखाओ",
  "general.button.closure": "हमें रेटिंग दें",
  "general.model.lable.tryToLog": "आप डालने की कोशिश कर रहे हैं",
  "general.model.lable.isNotComplaint":
    "क्या यह एक फ़ीडबैक है (प्रश्न / सुझाव / अनुसन्धान / अन्य मुद्दा) ?",
  "general.model.lable.or": "या",
  "general.model.lable.isComplaint": "क्या यह कंप्लेंट है ?",
  "general.model.lable.header.searchC": "खोज मापदंड",
  "general.model.lable.header.Client": "ग्राहक/संयंत्र",
  "general.model.button.continue": "जारी रखें",
  "general.model.lable.searchCriteria": "कृपया खोज मानदंड चुनें",
  "general.model.lable.searchCriteriaCustomer":
    "ग्राहक खोजने के लिए न्यूनतम 3 अक्षर टाइप करें",
  "general.model.lable.client": "कृपया ग्राहक/संयंत्र का चयन करें",
  "general.model.lable.feedbackDesc": "फीडबैक विवरण टाइप करें",
  "general.model.lable.subArea": "कृपया उपक्षेत्र चुनें",
  "general.model.lable.responseLogger": "कृपया लॉगर को प्रतिक्रिया दर्ज करें",
  "general.lebel.tagOldFeedback": "पुराने फ़ीडबैक को टैग करें",
  "general.button.upload": "अपलोड",
  "general.button.uploadFile": "फ़ाइल अपलोड करें",
  "general.label.client": "क्लाइंट",
  "general.lable.eventDate": "इवेंट तारीख",
  "general.select.clientSelect": "क्लाइंट का चयन करें",
  "general.select.birthDate": "जन्म दिन",
  "general.select.anniversary": "सालगिरह",
  "general.place-holder.select.list": "कृपया चुनें",
  "general.place-holder.date": "तारीख का चयन करें",
  "general.place-holder.input": "कृपया अपना इनपुट यहाँ दें",
  "general.place-holder.comment": "कृपया अपनी टिप्पणी दें",
  "general.error.client.required": "कृपया क्लाइंट चुनें",
  "general.error.event.required": "कृपया ईवेंट की तारीख चुनें",
  "general.error.feedbackType.required": "कृपया फ़ीडबैक प्रकार चुनें",
  "general.error.chooseFile.required": "कृपया एक फ़ाइल चुनें",
  "general.error.choosePdfFile.required": "कृपया पीडीएफ फाइल चुनें",
  "general.error.correctFileFormat.required": "कृपया सही फ़ाइल  चयन करें",
  "general.error.greaterFileSize.required":
    "फ़ाइल का आकार 5MB से अधिक है कृपया छोटी फ़ाइल चुनें",
  "general.error.shortFeedbackDescription.required":
    "छोटे फ़ीडबैक विवरण का उपयोग करें",
  "general.error.feedbackDescriptionSize.required":
    "आपका फीडबैक विवरण टेक्स्ट साइज काफी लंबा है।",
  "general.error.failAddFeedback.required": "फीडबैक जोड़ने में विफल",
  "general.success.feedback.msg": "फ़ीडबैक सफलतापूर्वक जोड़ा गया है",
  "general.lable.feedbackCodeIs": "आपका फीडबैक कोड है",
  "general.error.noteDownFeedback":
    "भविष्य के संपर्क के लिए फ़ीडबैक कोड को नोट करें",
  "general.label.feedbackdropdown": "संवादहीनता",
  "general.label.myAssignment": "मेरी असाइनमेंट",
  "general.chart.slaStatus": "एसएलए स्टेटस",
  "general.chart.feedbackByStatus": "फीडबैक स्टेटस",
  "general.button.moreClick": "अधिक क्लिक के लिए यहाँ क्लिक करें",
  "general.frontBox.newFeedback": "नई फीडबैक",
  "general.frontBox.slaViolation": "एसएलए विओलेशन",
  "general.frontBox.pickingViolation": "स्वीकार विओलेशन",
  "general.label.noDataFound": "कोई डेटा उपलब्ध नहीं है",
  "general.label.from": "बनाने वाला",
  "general.label.feedback.createdOn": "बनाया गया तारीख",
  "general.label.feedback.created": "बनाया गया",
  "general.label.timeElapsed": "समय बीता",
  "general.label.slaDate": "एसएलए तारीख",
  "general.label.remainingTime": "बचा हुआ समय",
  "general.label.slaOver": "एसएलए ओवर",
  "general.label.assignedFeedback": "असाइन किए गए फ़ीडबैक",
  "general.label.acceptedFeedback": "स्वीकृत फ़ीडबैक",
  "general.label.viewAsignedFeedback": "असाइन किए गए फ़ीडबैक सूची देखें",
  "general.label.viewAcceptedFeedback": "स्वीकृत फ़ीडबैक सूची देखें",
  "general.label.nameOrGroup": "नाम/समूह का नाम",
  "general.label.proceedText":
    "कृपया फ़ीडबैक को स्वीकार करने के लिए आगे प्रोसीड के बटन पर क्लिक करें",
  "general.msg.feedback.resolved":
    "फीडबैक का सफलतापूर्वक समाधान कर दिया गया है",
  "general.button.proceed": "प्रोसीड",
  "general.lable.confirmMessage": "कृपया निम्नलिखित की कन्फर्म करें",
  "general.lable.resolutionTargetTime": "रिज़ॉल्यूशन टारगेट समय",
  "general.button.accept": "मुझे स्वीकार है",
  "general.button.edit.hover.text": "इस एस्केलेशन मैट्रिक्स को संपादित करें",
  "general.button.resolverGrp.hover.text": "समाधानकर्ता समूह",
  "general.button.escalationLevel.hover.text": "वृद्धि स्तर",
  "general.button.add.text": "एक एस्केलेशन मैट्रिक्स पंक्ति जोड़ें",
  "general.button.remove.text": "इस एस्केलेशन मैट्रिक्स पंक्ति को हटा दें",
  "general.button.update.hover.text": "इस उपयोगकर्ता को अद्यतन करें",
  "general.button.remove.hover.text": "इस उपयोगकर्ता को हटाएं",
  "general.button.add.hover.text": "इस उपयोगकर्ता को हटाएं",
  "general.button.details.hover.text": "विवरण देखें",
  "general.lable.noUserFound": "इस समूह के लिए कोई यूजर नहीं मिला",
  "general.error.groupWiseUserListError":
    "समूह वार यूजर विवरण को लाते समय त्रुटि हुई",
  "general.label.msg.addReceipt": "रसीद को स्वीकार कर लिया गया है",
  "general.label.msg.addReceiptError": "रसीद को स्वीकार नहीं किया गया है",
  "general.label.msg.addReceiptSuccess":
    "आपने इस रसीद को सफलतापूर्वक स्वीकार कर लिया है",
  "general.label.msg.acceptingError": "फ़ीडबैक स्वीकार करते समय त्रुटि हुई",
  "general.lable.msg.noAssignmentSla": "कोई असाइनमेंट एसएलए पाया नहीं गया",
  "general.lable.msg.noEscalationFound": "कोई इसकलशं विवरण नहीं मिला",
  "general.lable.acceptReceipt": "कृपया स्वीकार करो",
  "general.lable.acceptReceiptTime": "सेकंड के भीतर",
  "general.error.addReceiptError":
    "रसीद जोड़ने और बंद होने के दौरान त्रुटि हुई",
  "general.lable.feedbackClosure": "फीडबैक क्लोज़ोर",
  "general.lable.contentHere": "अपनी सहमत यहां लिखें",
  "general.error.responseToLogger.required": "कृपया ग्राहक को प्रतिक्रिया दें",
  "general.error.rootCause.required": "कृपया मूल कारण प्रदान करें",
  "general.error.correctiveAction.required":
    "कृपया सुधारात्मक कार्रवाई प्रदान करें",
  "general.error.preventiveAction.required":
    "कृपया निवारक कार्रवाई प्रदान करें",
  "general.error.preventiveActionSize.required":
    "कृपया १५०० अक्षर के भीतर निवारक कार्रवाई प्रदान करें",
  "general.error.correctiveActionSize.required":
    "कृपया १५०० अक्षर के भीतर सुधारात्मक कार्रवाई प्रदान करें",
  "general.error.rootCauseSize.required":
    "कृपया १५०० अक्षरों में रूट का कारण प्रदान करें",
  "general.error.responseToLoggerSize.required":
    "लकड़हारा का ज्वाब बहुत लंबा है",
  "general.lable.slaViolatedFeedback": "एसएएल उल्लंघित फ़ीडबैक",
  "general.lable.pickingViolatedFeedback": "पीकिंग उल्लंघित फ़ीडबैक",
  "general.lable.slaViolatedFeedbackList":
    "एसएएल उल्लंघन की फ़ीडबैक लिस्ट देखें",
  "general.lable.pickingViolatedFeedbackList": "पीकिंग फीडबैक लिस्ट को देखें",
  "general.lable.reopenedFeedbackList": "फिर से खोला गया फ़ीडबैक सूची देखें",
  "general.lable.reopenedReason": "फीडबैक फिर से खोलना कारण",
  "general.lable.newFeedbackList": "नई फ़ीडबैक सूची देखें",
  "general.lable.viewSLA": "एसएलए देखें",
  "general.lable.slaCondition": "एसएलए कंडीशन",
  "general.lable.pickUpTarget": "पिक उप टारगेट",
  "general.lable.pickUpTargetTime": "पिक उप टारगेट समय",
  "general.lable.oldFeedbacks": "पुरानी फ़ीडबैक",
  "general.lable.editTagUntage": "टैग/अनटैग को संशोधित करें",
  "general.lable.unTagOldFeedback": "अनटैग ओल्ड फ़ीडबैक",
  "general.lable.taggedBy": "द्वारा टैग की गईं",
  "general.lable.feedbackId": "फ़ीडबैक आईडी",
  "general.lable.plant": "प्लांट",
  "general.lable.resolvedComplaint": "रिजॉल्वड कंप्लेंट",
  "general.lable.resolvedComplaintList": "रिजॉल्वड कंप्लेंट लिस्ट देखें",
  "general.lable.complaintSlaViolated": "फ़ीडबैक एसएलए उल्लंघन",
  "general.lable.complaintSlaViolatedList": "फ़ीडबैक एसएलए उल्लंघन लिस्ट देखें",
  "general.lable.otherSlaViolated": "अन्य एसएलए उल्लंघन",
  "general.lable.othersSlaViolatedList": "अन्य एसएलए उल्लंघन लिस्ट देखें",
  "general.lable.reopenedAndResolved": "पुनः खोलें और रिजॉल्वड कंप्लेंट",
  "general.lable.reopenedAndResolvedList":
    "पुनः खोलें और रिजॉल्वड कंप्लेंट लिस्ट देखें",
  "general.lable.complaintRepeated": "बार-बार कंप्लेंट फ़ीडबैक",
  "general.lable.complaintRepeatedList": "बार-बार कंप्लेंट फ़ीडबैक लिस्ट देखें",
  "general.lable.slaAlert": "एसएलए अलर्ट",
  "general.lable.slaAlertList": "एसएलए अलर्ट लिस्ट देखें",
  "general.lable.EscNoOfRowsAlert":
    "10 से अधिक स्तर की वृद्धि की अनुमति नहीं है",
  "general.lable.errorMessage": "कुछ गलत हुआ",
  "general.exception.errorMessage.response.fileUpload":
    "सर्वेक्षण प्रतिक्रिया अपलोड के दौरान त्रुटि हुई।",
  "general.exception.successMessage.response.fileUpload":
    "सर्वेक्षण प्रतिक्रिया सफलतापूर्वक अपलोड की गई",
  "general.lable.errorMessage.mappedDepartment":
    "वर्तमान में आप किसी भी विभाग के साथ मैप नहीं किए गए हैं। आगे सहायता के लिए कृपया सिस्टम व्यवस्थापक से संपर्क करें।",
  "general.lable.message.searchInputsError":
    "अनुरोध किए गए विवरण नहीं मिले हैं। कृपया तदनुसार खोज करने के लिए अधिक इनपुट प्रदान करें।",
  "general.lable.message.noConsentFound": "कोई सहमति नहीं मिला",
  "general.lable.message.satisfiedFeedbackCode": "आप संतुष्ट हैं फीडबैक कोड",
  "general.lable.message.dropdown.satisfied": "संतुष्ट",
  "general.lable.message.dropdown.notsatisfied": "संतुष्ट नहीं",
  "general.lable.message.registerFreshComplaint":
    "इसलिए इसे फिर से खोला नहीं जा सकता, इसे अनुरोध है कि आप अपनी पिछली फ़ीडबैक / कंप्लेंट नंबर पर टैगिंग के माध्यम से एक नई कंप्लेंट दर्ज करें।",
  "general.lable.message.nonSatisfied":
    "आपके बहुमूल्य फ़ीडबैक के लिए धन्यवाद, आपकी प्रतिक्रिया संबंधित विभाग को भेजी जाएगी और इसके अनुसार कार्रवाई की जाएगी।",
  "general.lable.message.satisfied":
    "आपके बहुमूल्य फ़ीडबैक के लिए धन्यवाद, आपकी प्रतिक्रिया संबंधित विभाग को भेजी जाएगी।",
  "general.lable.message.nonSatisfiedFeedbackCode":
    "हमें सिस्टम में पहले से ही फीडबैक {1} के लिए {0} के रूप में गर-संतुष्टि कारण मिला है। इसलिए तदनुसार कार्रवाई करें। इसलिए तदनुसार कार्रवाई करें।",
  "general.lable.message.unTag": "अनटैग",
  "general.lable.message.tag": "टैग",
  "general.lable.message.confirmation": "कन्फर्मेशन की आवश्यकता है",
  "general.lable.message.confirmationMessage":
    "क्या आप वाकई चयनित फ़ाइल को अपलोड किए बिना फ़ीडबैक जोड़ना चाहते हैं?",
  "general.lable.message.uploadSelectedFile":
    "कृपया आगे बढ़ने से पहले चयनित फ़ाइल अपलोड करें",
  "general.lable.message.dashboard":
    "सभी डैशबोर्ड डेटा वर्तमान समय से ३ महीने पर आधारित हैं",
  "general.lable.message.dashboardCST":
    "सभी डैशबोर्ड डेटा डिफ़ॉल्ट रूप से चालू दिनांक से ३ महीने पर आधारित होते हैं",
  "general.lable.message.dashboard.toDateAtMostCurrentDate":
    "टो डेट वर्तमान तारीख से अधिक नहीं हो सकता!",
  "general.lable.message.dashboard.fromDateMaxThreeMonthsLessThanToDate":
    "फ्रॉम डेट तो डेट  तीन महीने पहले नहीं हो सकता!",
  "general.label.dashboard.hello": "नमस्कार",
  "general.label.dashboard.greeting.text": "ग्रीटिंग! आपका दिन शुभ हो।",
  "general.button.message.text": "परेन्ट पर जाएं",
  "general.lable.message.feedbackAttachment": "फ़ीडबैक अटैचमेंट लिस्ट",
  "general.lable.message.responseAttachment": "रेस्पोंसेद अटैचमेंट लिस्ट",
  "general.lable.message.notifications": "सुचनाएँ",
  "general.lable.message.toggleFullScreen": "टॉगल पूर्णस्क्रीन",
  "general.lable.message.switchRole": "भूमिका स्विच करें",
  "general.lable.message.openDashboardCriteriaPanel":
    "ओपन डैशबोर्ड मानदंड पैनल",
  "general.lable.gstNo.text": "जीएसटी नंबर",
  "general.lable.userType.text": "उपयोगकर्ता का प्रकार",
  "general.mobileNumber.empty": "कृपया मोबाइल नंबर दर्ज करें",
  "general.name.empty": "कृपया नाम दर्ज करें",
  "general.exception.errorMessage.fileUpload":
    "फ़ाइल अपलोड के दौरान त्रुटि हुई।",
  "general.error.message.action.no.priviledged":
    "क्षमा करें, इसे लगता है कि आपको इस कार्रवाई के लिए आवश्यक अधिकार नहीं हैं।",
  "general.message.select.resolution.group":
    "कृपया वांछित संकल्प समूह का चयन करें।",
  "general.label.reffDocNo": "संदर्भ दस्तावेज संख्या",
  "general.tooltip.reffDocNo":
    "दर सूची से, कृपया आर्थिक और अन्य मुद्दों के लिए उल्लेख करें या मुद्दों के लिए उल्लेख करें।",
  "general.label.similarFeedbackCode":
    "इसी तरह की प्रतिक्रिया / शिकायत को संदर्भित करें? (कृपया प्राथमिकता से चयन करें)",
  "general.lebel.closeFeedbackList": "फीडबैक सूची बंद करें",
  "general.error.feedbackDescription": "कृपया प्रतिक्रिया विवरण प्रदान करें",
  "general.label.eventName": "इवेंट / आइटम का नाम",
  "general.label.rfqNo": "आरएफक्यू नंबर",
  "general.validation.empty.feedback.description":
    "फीडबैक विवरण खाली नहीं हो सकता।",
  "general.label.filter.clear.button": "रीसेट डैशबोर्ड",
  "feedback.user.email.empty": "यूजर का ईमेल खाली नहीं हो सकता",
  "feedback.user.email.pattern.missmatch":
    "यूजर का ईमेल पैटर्न मेल नहीं करता है",
  "general.label.dashboard.question.to.select.year":
    "आप किस वर्ष का प्रबंधन करना चाहेंगे?",
  "general.validation.empty.feedback.department.id": "अमान्य विभाग/सेवा आईडी",
  "general.validation.empty.feedback.serviceMail.subject":
    "अमान्य/खाली ईमेल विषय मिला",
  "general.validation.empty.user": "उपयोगकर्ता नहीं मिला",
  "general.validation.unknown.department": "विभाग अज्ञात !!",
  "general.validation.unknown.error": "त्रुटि हुई !!",
  "general.validation.unknown.customer": "कोई ग्राहक नहीं मिला।",
  "general.validation.select.customer": "उपयोगकर्ता का चयन करें",
  "general.label.customer.id": "ग्राहक आईडी",
  "general.lable.user.select": "उपयोगकर्ता का चयन करें",
  "general.validation.choose.customer": "कृपया पहले ग्राहक का चयन करें !!",
  "general.label.clientOrDept": "क्लाइंट / विभाग",
  "general.validation.input.invalid": "अमान्य इनपुट मिला",
  "general.session.current-session.invalidated":
    "वर्तमान सत्र को अमान्य किया गया है।",
  "general.label.text.pleaseChoose": "कृपया इनमेसेज चुनें",
  "general.session.invalidate.current-session": "वर्तमान सत्र को अमान्य करें",
  "general.session.invalidate.previous-session": "पिछले सत्र को अमान्य करें",
  "general.message.additional.info.panel.header": "अतिरिक्त जानकारी",
  "general.message.additional.info.button.update":
    "अतिरिक्त जानकारी अपडेट करें",
  "general.message.additional.info.minimum.input":
    "कृपया सुनिश्चित करें कि पहले अतिरिक्त मैलबॉक और नुनतम एक इनपुट दिया गया है।",
  "general.message.additional.info.provide.attribute.prefix":
    "क्या आप अतिरिक्त जानकारी में",
  "general.message.additional.info.provide.attribute.suffix": "प्रदान करें।",
  "general.message.additional.info.save.attribute.confirmation.prefix":
    "क्या आप वाकई अतिरिक्त जानकारी करना चाहते हैं।",
  "general.message.additional.info.save.attribute.confirmation.suffix":
    "अपडेट करने के लिए।",
  "general.message.text.and": "और",
  "close.feedback.message.closure.mail.user.selection.panel.header":
    "मेल उपयोगकर्ता चयन पैनल बंद करें",
  "close.feedback.message.closure.mail.user.selection.head.instruction":
    "कृपया क्लोजर मेल को बंद करने के लिए इनमेल और न्यूनतम एक इनपुट दिया गया है।",
  "close.feedback.message.closure.mail.user.selection.empty.avail.user":
    "कोई योग्य उपयोगकर्ता नहीं मिला है।",
  "close.feedback.message.closure.mail.user.selection.empty.selected.user":
    "कृपया कोई उपयोगकर्ता चयन करें या आइटम को चुनें।",
  "page.view.escalation.matrix.panel.main.head": "एस्केलेशन मैट्रिक्स देखें",
  "page.edit.escalation.matrix.panel.main.head":
    "एस्केलेशन मैट्रिक्स संपादित करें",
  "page.edit.escalation.matrix.label.assignmentSlaMin": "असाइनमेंट एसएलए मिनट",
  "page.edit.escalation.matrix.label.pickupSlaMin": "पिकअप एसएलए मिनट",
  "page.edit.escalation.matrix.label.resolutionSlaMin":
    "रेज़ॉल्यूशन एसएलए मिनट",
  "page.edit.escalation.matrix.label.resolverGroup": "रेज़ॉल्यूशन ग्रुप",
  "page.edit.escalation.matrix.title.blank.resolverGroup":
    "कृपया एक ग्रुप चुनें",
  "page.edit.escalation.matrix.label.slaEscalation": "एस्केलेशन",
  "page.edit.escalation.matrix.escalation.table.header.level": "एस्केलेशन लेवल",
  "page.edit.escalation.matrix.escalation.table.header.group":
    "एस्केलेशन ग्रुप",
  "page.edit.escalation.matrix.escalation.table.header.time":
    "एस्केलेशन टाइम(मिनट)",
  "page.edit.escalation.matrix.escalation.table.header.user": "एस्केलेशन यूजर",
  "page.edit.escalation.button.label.updateSlaDetails": "अपडेट एसएलए डिटेल्स",
  "page.edit.escalation.button.label.updateEscalationDetails":
    "अपडेट एस्केलेशन डिटेल्स",
  "page.edit.escalation.field.error.pickupSla":
    "कृपया पिकअप एसएलए समय दर्ज करें",
  "page.edit.escalation.field.error.resolverGroup":
    "कृपया रिसॉल्वर ग्रुप का चयन करें",
  "page.edit.escalation.sla.update.success":
    "एस्केलेशन सफलतापूर्वक अपडेट किया गया",
  "page.edit.escalation.field.error.select.group.left":
    "कृपया एस्केलेशन स्टेप नंबर छोड़ें",
  "page.edit.escalation.field.error.select.group.right":
    "के लिए एस्केलेशन ग्रुप चुनें",
  "page.edit.escalation.field.error.select.time.left":
    "कृपया एस्केलेशन चरण संख्या",
  "page.edit.escalation.field.error.select.time.right":
    "के लिए एस्केलेशन समय दर्ज करें",
  "page.edit.escalation.matrix.data.missing":
    "कृपया कम से कम एक से कम एक एस्केलेशन ग्रुप जानकारी के साथ सही कम संख्या का चयन करें",
  "page.edit.escalation.matrix.update.success":
    "एस्केलेशन स्ट्रेटेजी सफलतापूर्वक अपडेट किया गया",
  "page.edit.escalation.error.no.more.step.left": "",
  "page.edit.escalation.error.no.more.step.right":
    "से अधिक एस्केलेशन स्ट्रेटेजी की अनुमति नहीं है",
  "page.edit.escalation.field.error.select.time.whole-number.left":
    "एस्केलेशन चरण नंबर",
  "page.edit.escalation.field.error.time.whole-number.right":
    "के समय संख्या और सुनिश्चित करें कि यह पूर्णांक (1) से अधिक और शून्य नहीं है",
  "page.view.master.area.panel.main.head": "मुख्य क्षेत्र देखें",
  "page.view.sub.area.panel.main.head": "अतिरिक्त क्षेत्र देखें",
  "page.add.master.area.panel.main.head": "मुख्य क्षेत्र जोड़ें",
  "page.add.sub.area.panel.main.head": "अतिरिक्त क्षेत्र जोड़ें",
  "page.view.master.area.id": "मुख्य क्षेत्र आईडी",
  "page.view.sub.area.id": "अतिरिक्त क्षेत्र आईडी",
  "page.modify.master.area.panel.main.head": "मुख्य क्षेत्र एडिट करें",
  "page.modify.sub.area.panel.main.head": "अतिरिक्त क्षेत्र एडिट करें",
  "general.error.msg.unknown": "कुछ गलत हो गया",
  "general.label.serial.number.short": "",
  "label.department.description": "विभाग विवरण",
  "label.master.area.description": "उप क्षेत्र विवरण",
  "general.label.areaOfConcern": "चिंता का क्षेत्र",
  "general.label.orderId": "आर्डर संख्या",
  "general.label.itemId": "आइटम आईडी",
  "general.label.feedback.tag.dataDuration":
    "***पुरानी प्रतिक्रिया सूची डेटा वर्तमान तिथि से पिछले 90 दिनों पर आधारित है।",
  "general.label.user.email.absence":
    "***ईमेल की अनुपस्थिति ग्राहक के लिए साइस्टम जनरेटेड मेल को ट्रिगर नहीं करेगी",
  "general.field.serviceUserId.validation.notEmpty":
    "कोई बीयू उपयोगकर्ता आईडी नहीं मिली",
  "general.field.department.id.validation.notEmpty":
    "कोई सर्विस आईडी नहीं मिली",
  "general.tab.discardFeedback.text": "फीडबैक हटाएं",
  "general.lable.discardedComment.text": "हटाए गए कमेंट्स करें",
  "general.label.required.comment": "अपनी टिप्पणी दर्ज करें",
  "general.label.comment": "कृपया अपनी टिप्पणी दें",
  "general.label.discardComment.paceholder": "कृपया करके आवश्यक टिप्पणी डालें!",
  "general.error.discardComment.confirm":
    "क्या आप प्रतिक्रिया हटाएंगे सुनिश्चित कर रहे हैं?",
  "general.error.discardComment.required":
    "प्रतिक्रिया हटाने के लिए टिप्पणी आवश्यक है",
  "general.error.discardComment.length":
    "ताग की टिप्पणी ०० से अधिक वर्ण नहीं हो सकती",
  "general.label.feedback.reassignment": "प्रतिक्रिया पुनर्नियुक्ति",
  "general.label.feedback.reassign": "पुनर्नियुक्ति",
  "feedback.reassignment.confirmation.left": "क्या आप वाकई फ़ीडबैक",
  "feedback.reassignment.confirmation.right":
    "को पुनर्नियुक्त करना चाहते हैं ?",
  "err.msg.user.auth.not.found.or.self.or.customer":
    "उपयोगकर्ता प्रमाणीकरण नहीं मिला या स्व-प्रमाणित मिला या ग्राहक-प्रमाण मिला",
  "general.label.reset.password": "रीसेट पासवर्ड",
  "general.label.removeUser.text": "उपयोगकर्ता को सफलतापूर्वक हटा दिया गया",
  "general.label.addUser.text": "उपयोगकर्ता सफलतापूर्वक जोड़ा गया",
  "reset.password.confirmation.left": "क्या आप वाकई उपयोगकर्ता",
  "reset.password.confirmation.right": "के लिए पासवर्ड रीसेट करना चाहते हैं ?",
  "reset.password.success.msg": "पासवर्ड रीसेट सफल हुआ",
  "reset.password.failure.msg": "पासवर्ड रीसेट करने में विफल",
  "menu.key.survey.view": "सर्वेक्षण देखें",
  "menu.key.survey": "सर्वेक्षण",
  "title.new.surveyList.viewSurvey": "सर्वेक्षण सूची देखें",
  "label.new.surveyList.SLNo": "क्रमांक",
  "label.new.survey.surveyId": "सर्वेक्षण आईडी",
  "label.new.survey.surveyName": "सर्वेक्षण का नाम",
  "label.new.survey.surveyStartDate": "सर्वेक्षण प्रारंभ तिथि",
  "general.tab.survey.surveyEndDate": "सर्वेक्षण समाप्ति तिथि",
  "label.new.survey.avgScore": "औसत अंक",
  "label.new.survey.submitCount": "प्रस्तुत संख्या",
  "general.button.download": "डाउनलोड",
  "general.button.viewDetails": "विवरण देखें",
  "label.new.survey.Action": "गतिविधि",
  "button.label.survey.response.upload": "अपलोड सर्वेक्षण प्रतिक्रिया",
  "menu.key.survey.detail.view": "सर्वेक्षण विवरण देखें",
  "label.new.survey.surveySubmitId": "सर्वेक्षण जमा आईडी",
  "label.new.survey.userName": "उपयोगकर्ता नाम",
  "label.new.survey.submitDate": "जमा करने की तारीख",
  "general.tab.survey.score": "अंक",
  "label.new.survey.result": "परिणाम",
  "label.new.survey.status": "स्थिति",
  "label.new.survey.answerId": "उत्तर आईडी",
  "label.new.survey.question": "प्रश्न",
  "label.new.survey.option": "चयनित विकल्प",
  "general.tab.survey.descrition": "विवरण",
  "label.new.survey.remark": "टिप्पणी",
  "label.new.survey.taskforce": "टास्क फोर्स",
  "label.new.survey.actionpoint": "कार्रवाई के बिंदु",
  "label.new.survey.timeline": "समय रेखा",
  "general.exception.successMessage.response.submit":
    "सर्वेक्षण प्रतिक्रिया सफलतापूर्वक सबमिट की गई।",
  "general.exception.errorMessage.response.submit":
    "सर्वेक्षण प्रतिक्रिया सबमिट के दौरान त्रुटि हुई।",
  "label.new.survey.organization": "संगठन का नाम",
  "label.new.survey.noOfPassSurvey": "उत्तीर्ण सर्वेक्षण",
  "label.new.survey.noOfFailedSurvey": "विफल सर्वेक्षण",
  "general.label.tenderNo": "टेंडर संख्या",
  "general.label.userAdded": "उपयोगकर्ता सफलतापूर्वक जोड़ा गया है",
  "general.label.actionpoint.error": "कृपया अपना कार्यबिंदु प्रदान करें",
  "general.label.nodata.error": "दिखाने के लिए कोई डेटा नहीं",
  "general.label.assign.group": "समूह असाइन करें",
  "general.label.assign.group": "समूह असाइन करें",
  "general.label.dashboard.data":
    "वर्तमान तिथि से पिछले 3 महीनों के आधार पर अधिकतम 100 डेटा दिखाए गए हैं",
  "general.label.analytics.dashboard": "एनालिटिक्स डैशबोर्ड",
  "general.label.dashboard.button.addFeedback": "शिकायत/प्रतिक्रिया",
  "general.label.tagged.feedback": "टैग की गई प्रतिक्रिया",
  "general.label.userAdded": "उपयोगकर्ता सफलतापूर्वक जोड़ा गया है",
  "general.label.actionpoint.error": "कृपया अपना कार्यबिंदु प्रदान करें",
  "general.label.nodata.error": "दिखाने के लिए कोई डेटा नहीं",
  "general.label.assign.group": "समूह असाइन करें",
  "general.label.assign.group": "समूह असाइन करें",
  "general.label.analytics.dashboard": "एनालिटिक्स डैशबोर्ड",
  "general.label.dashboard.button.addFeedback": "शिकायत/प्रतिक्रिया",
  "general.label.dashboard.button.manage.my.history": "मैनेज माय हिस्ट्री",
  "general.label.tagged.feedback": "टैग की गई प्रतिक्रिया",
  "general.label.to.do.list": "टू-डू सूची",
  "general.label.notagged.feedback": "कोई टैगड फीडबैक नहीं है",
  "general.label.to.do.list.subject": "विषय",
  "general.label.consent.feedback": "सहमति/टिप्पणी",
  "general.label.take.note": "टेक नोट ",
  "general.label.comment.details": "टिप्पणी विवरण",
  "general.label.add.comment": "टिप्पणी जोड़ें",
  "general.label.no.comments": "अभी तक कोई टिप्पणी नहीं",
  "general.label.comment.submitted": "टिप्पणी सफलतापूर्वक सबमिट हुई!",
  "general.button.submitting.label": "सबमिट हो रहा है...",
  "general.label.add.a.to.do": "नोट जोड़ना",
  "menu.key.master.group": "समनुदेशिती समूह",
  "general.label.filter": "फ़िल्टर",
  "general.label.rate.now": "अभी रेट करें",
  "general.label.rating": "रेटिंग",
  "general.label.apply.filter": "अप्लाई फ़िल्टर",
  "general.label.apply": "अप्लाई",
  "general.label.ongoing.complaint": "सबसे हाल ही में",
  "general.label.contact.info": "संपर्क सूचना",
  "general.label.history": "इतिहास",
  "general.label.attachment": "अटैचमेंट",
  "general.label.no.attachment": "नो अटैचमेंट",
  "general.label.subject": "विषय",
  "general.label.replied": "जवाब दिया गया",
  "general.label.to": "को",
  "general.label.kb": "के.बी",
  "general.label.upload.complete": "अपलोड पूर्ण!",
  "general.label.calendar": "पंचांग",
  "general.label.Clearall": "सभी साफ करें",
  "general.label.comment": "कृपया एक टिप्पणी दें",
  "general.label.resolver.noData": "कोई समाधानकर्ता विवरण उपलब्ध नहीं है",
  "general.label.reason.unsatisfaction": "कृपया असंतोष का कारण दर्ज करें",
  "general.label.feedback.satisfaction":
    "अपनी संतुष्टिपूर्ण प्रतिक्रिया प्रस्तुत करने के लिए धन्यवाद",
  "general.label.enter.reason": "कारण दर्ज करें",
  "general.label.tagged": "टैग",
  "general.label.no.data.available": "कोई डेटा मौजूद नहीं",
  "general.label.escalation.step": "वृद्धि चरण",
  "general.label.assignee.name.group": "समनुदेशिती का नाम/समूह",
  "general.label.escalation.time": "वृद्धि समय (DD-MM-YYYY HH:MM)",
  "general.label.no.slaDetails": "कोई SLA विवरण उपलब्ध नहीं है",
  "general.label.mandatory.fields": "कृपया सभी अनिवार्य फ़ील्ड भरें",
  "general.label.feedback.code": "फीडबैक सफलतापूर्वक जोड़ा गया. फीडबैक कोड: ",
  "general.label.note.feedback.code":
    "  कृपया भविष्य के संदर्भ के लिए नोट कर लें.",
  "general.label.feedback.required": "प्रतिक्रिया विवरण आवश्यक है.",
  "general.label.unfortunately.no.feedback.submit":
    "दुर्भाग्य से, प्रतिक्रिया सबमिट नहीं कर सका. ",
  "general.label.unfortunately.feedback.already.present.submit":
  "इस कॉलबैक अनुरोध के लिए फीडबैक पहले से ही जोड़ा गया है",
  "general.label.search.user": "उपयोगकर्ता खोजें",
  "general.label.onlysimilarFeedbackCode":
    "क्या आप पिछली समान प्रतिक्रिया/शिकायत का उल्लेख करना चाहते हैं?",
  "general.label.customer.org": "ग्राहक संगठन.",
  "general.label.user.updated": "उपयोगकर्ता सफलतापूर्वक अपडेट किया गया",
  "general.label.header.filled": "कृपया टेक्स्ट फ़ील्ड भरें",
  "general.label.modal.title": "मॉडल शीर्षक",
  "general.label.escape.key":
    "यदि आप मेरे बाहर क्लिक करेंगे तो मैं बंद नहीं करूंगा। एस्केप कुंजी दबाने का प्रयास भी न करें.",
  "general.label.Understood": "समझा",
  "general.label.feedback.info": "प्रतिक्रिया सूचना",
  "general.label.Success": "सफलता",
  "general.label.reopen.feedback": "फीडबैक पुनः खोलें",
  "general.label.tagged.feedback": "टैग की गई प्रतिक्रिया",
  "general.label.annually": "हर साल",
  "general.label.3.months": "3 महीने",
  "general.label.6.months": "6 महीने",
  "general.label.custom.date": "कस्टम तिथि",
  "general.label.feedback": "प्रतिक्रिया",
  "general.label.complaint.status": "शिकायत की स्थिति",
  "general.label.complaint.overall": "कुल मिलाकर शिकायत",
  "general.label.feedback.overall": "समग्र प्रतिक्रिया",
  "general.label.reviews.overall": "समग्र समीक्षाएँ",
  "general.label.greeting": "अभिवादन! शानदार दिन हो",
  "general.label.hello": "नमस्ते",
  "general.label.feedback.general.query": "प्रतिक्रिया/सामान्य प्रश्न",
  "general.footer.label.copyRight": "© 2025 एमजंक्शन सर्विसेज लिमिटेड.",
  "general.footer.label.version": "संस्करण 5.0",
  "general.label.feedback.advance.filter": "अग्रिम फ़िल्टर",
  "general.label.Select.option": "कोई विकल्प चुनें",
  "general.label.Screen.resize": "स्क्रीन का आकार बदलें",
  "general.label.language": "भाषा",
  "general.label.english": "अंग्रेज़ी",
  "general.label.hindi": "हिंदी",
  "general.label.login": "लॉग इन करें",
  "general.label.max.login": "इस उपयोगकर्ता के लिए अधिकतम सत्र 1 से अधिक हो गए",
  "general.label.logout.prevstate": "पिछले सत्र से लॉगआउट करें",
  "general.label.logout.current": "इस सत्र से लॉगआउट करें",
  "general.label.feedback.closure.failed": "फीडबैक बंद करने में विफल",
  "label.new.feedbacklist.phoneAndMobileNo": "मोबाइल नंबर और पीएच नंबर",
  "general.label.feedback.reopen.and.reassign":
    "फीडबैक पुनः खोलें और पुन: असाइन करें",
  "general.label.feedback.reassign": "फीडबैक पुन: असाइन करें",
  "general.label.bidder.organixation": "बोलीदाता संगठन",
  "general.label.input.invalid": "अमान्य निवेश",
  "general.label.search.organisation": "खोज संगठन",
  "general.label.enter.link": "लिंक का यूआरएल दर्ज करें:",
  "general.label.untagged": "फीडबैक सफलतापूर्वक अनटैग किया गया",
  "general.label.nofeedback": "पिछले तीन महीनों से कोई प्रतिक्रिया नहीं",
  "general.label.nofeedback": "सभी को देखें",
  "general.label.native": "देशी",
  "general.label.error": "उफ़! कुछ गलत हो गया.",
  "general.label.inconvenience.error": "असुविधा के लिए हम खेद व्यक्त करते हैं.",
  "general.label.go.home": "घर जाओ",
  "general.label.log.out": "लॉग आउट",
  "general.label.report.type": "आख्या की प्रकार",
  "general.label.overdue": "अतिदेय",
  "general.label.high.priority": "उच्च प्राथमिकता",
  "general.label.Medium.Priority": "मध्यम प्राथमिकता",
  "general.label.Low.Priority": "कम प्राथमिकता",
  "general.label.below": "नीचे ",
  "general.label.active": "सक्रिय",
  "general.label.accepted": "स्वीकृत",
  "general.label.firstname.required": "पहला नाम आवश्यक है",
  "general.label.lastname.required": "अंतिम नाम आवश्यक है",
  "general.label.email.required": "अमान्य ईमेल पता",
  "general.label.email.isrequired": "ईमेल की जरूरत है",
  "general.label.mobile.required": "मोबाइल नंबर आवश्यक है",
  "general.label.address.required": "पता आवश्यक है",
  "general.label.mobile.invalid": "अमान्य मोबाइल नंबर",
  "general.label.confirm": "पुष्टि करना",
  "general.label.add.authority": "अधिक अधिकार जोड़ें",
  "general.label.role": "निम्नलिखित भूमिकाएँ?",
  "general.label.no.authority":
    "क्या आप वाकई इसे कोई अधिकार नहीं देना चाहते हैं?",
  "general.label.fromdate.required": "तारीख से आवश्यक है",
  "general.label.option.menu": "इस चयन मेनू को खोलें",
  "general.label.role.switch": "भूमिका बदलें",
  "general.label.bidder.organization": "बोलीदाता संगठन",
  "general.label.mobile.no": "मोबाइल नंबर",
  "general.label.phone.no": "फ़ोन नंबर",
  "general.label.dept.id": "विभाग आईडी",
  "general.label.user.id": "उपयोगकर्ता पहचान",
  "general.label.format": "प्रारूप",
  "general.label.Locale": "स्थान",
  "general.label.download.excel.date": "एक्सेल डेटा डाउनलोड करें",
  "general.label.department.required": "विभाग की आवश्यकता है",
  "general.label.Organization.required": "संगठन का नाम आवश्यक है",
  "general.label.Invalid.PAN.number.format": "अमान्य PAN नंबर प्रारूप",
  "general.label.Invalid.GST.number.format": "अमान्य GST नंबर प्रारूप",
  "general.label.Select.user.type": "उपयोगकर्ता प्रकार चुनें",
  "general.label.User.type.required": "उपयोगकर्ता प्रकार आवश्यक है",
  "general.label.Search.EmailId": "ईमेल आईडी खोजें",
  "general.label.Search.Customer.Id": "ग्राहक आईडी खोजें",
  "general.label.Search.Pan.No": "PAN नंबर खोजें",
  "general.label.Search.Mobile.No": "मोबाइल नंबर खोजें",
  "general.label.Search.Phone.No": "फ़ोन नंबर खोजें",
  "general.label.Search.Vendor.Code": "विक्रेता कोड खोजें",
  "general.label.Status.required": "स्थिति आवश्यक है",
  "general.label.Consent.required": "सहमति आवश्यक है",
  "general.label.view.all": "सभी को देखें",
  "general.label.user.list": "उपयोगकर्ता सूची",
  "general.label.choose.file": "फ़ाइल चुनें",
  "general.label.no.file.chosen": "कोई फ़ाइल चयन नहीं की गई",
  "label.new.survey.timeleft": "शेष समय",
  "label.general.navigation.back.to.complaint.list":
    "शिकायतों/फीडबैक पर वापस जाएं",
  "general.exception.errorMessage.feedbackDesc.correctiveaction":
    "सुधारात्मक कार्रवाई की आवश्यकता है",
  "general.exception.errorMessage.feedbackDesc.preventiveaction":
    "निवारक कार्रवाई आवश्यक है",
  "general.exception.errorMessage.feedbackDesc.rootcause": "मूल कारण आवश्यक है",
  "general.exception.errorMessage.feedback.required": "फीडबैक प्रकार आवश्यक है",
  "general.exception.errorMessage.feedback.source.required":
    "प्रतिक्रिया स्रोत आवश्यक है",
  "min.letter.required": "न्यूनतम {{num}} अक्षर दर्ज करें",
  "general.lable.message.Role": "भूमिका",
  "general.exception.errorMessage.comment.consentUser.required":
    "उपयोगकर्ता की सहमति आवश्यक है",
  "general.label.generic.queries": "सामान्य प्रश्न",
  "general.label.search.queries": "अपने प्रश्न खोजें",
  "general.label.enter.verification.code": "सत्यापन कोड दर्ज करें",
  "general.label.resend.otp.in": "OTP दोबारा भेजें",
  "general.label.resend.otp": "OTP दोबारा भेजें",
  "general.label.send.reply": "भेजें",
  "general.label.feedbackUpdates": "प्रतिक्रिया अद्यतन",
  "general.description.feedback.update":
    "फीडबैक उपयोगकर्ता को एक अद्यतन प्रदान करें",
  "general.label.send.otp.success": "OTP सफलतापूर्वक भेज दिया गया है",
  "mail.sent.success.message": "मेल सफलतापूर्वक भेज दिया गया है",
  "chatbox.chatbot.greetings.message":
    "नमस्ते, मैं अभी आपकी कैसे मदद कर सकता हूँ? आप मुझसे कुछ भी पूछ सकते हैं!",
  "chatbox.agent.greeting.message.to.customer":
    "नमस्ते {name}, मैं आपकी कैसे मदद कर सकता हूँ?",
  "chatbox.agent.no.customer.waitig":
    "फिलहाल कोई भी ग्राहक कतार में इंतजार नहीं कर रहा है.",
  "chatbox.customer.queue.position":
    "कृपया कुछ मिनट प्रतीक्षा करें, आप कतार में {{p}} स्थान पर हैं।",
  "chatbox.customer.not.satisfied.text":
    "यदि आपके प्रश्न का उचित उत्तर नहीं दिया गया है तो आप हमारे ग्राहक प्रतिनिधि से बात कर सकते हैं या चैट जारी रख सकते हैं।",
  "chatbox.chat.with.agent": "एजेंट से चैट करें",
  "chatbox.chat.with.bot.continue": "जारी रखें",
  "chatbox.tooltip.customer": "मदद की ज़रूरत है?",
  "chatbox.tooltip.agent": "चैट सहायता दें",
  "chatbox.customer.callback.request.added":
    "आपका कॉलबैक अनुरोध प्रक्रियाधीन है. हम शीघ्र ही आपसे संपर्क करेंगे",
  "chatbox.choose.desired.option": "हम आपकी कैसे मदद कर सकते हैं?",
  "chatbox.callback.comment.submitted": "टिप्पणी सफलतापूर्वक सबमिट की गई",
  "chatbox.callback.comment.submitted.unsuccessful":
    "दुर्भाग्य से टिप्पणी सबमिशन विफल रहा। कृपया कुछ समय बाद पुनः प्रयास करें",
  "chatbox.callback.comment.submitted.unsuccessful.msg":
    "कृपया पिछली टिप्पणी के {timeDiff} सेकंड बाद नई टिप्पणी सबमिट करें",
    "chatbox.callback.request.submit": "कॉलबैक का अनुरोध करें",
    "chatbot.chat.with.bot":"बॉट के साथ चैट करें",
    "chatbot.agent.delete.chat": "चैट हटाएँ",
    "chatbox.user.ended.chat": "यह चैट ख़त्म हो गई है.",
    "chatbox.customer.end.chat": "इस चैट को समाप्त करें",
    "chatbox.agent.end.user.chat":"चैट समाप्त करें और हटाएँ",
    "chatbox.customer.end.chat.modal.body": "क्या आप वाकई इस चैट को समाप्त करना चाहते हैं? एक बार डिलीट होने के बाद आपको नई चैट शुरू करनी होगी।",
    "chatbox.agent.end.chat.modal.body" : "क्या आप वाकई इस चैट को समाप्त करना और हटाना चाहते हैं? सुनिश्चित करें कि उपयोगकर्ता की समस्या हल हो गई है.",
    "generel.lebel.cancel.confirmation" : "आप आप रद्द करना चाहते हैं?",
    "chatbox.customer.chat.ended.message": "यह चैट ख़त्म हो चुकी है. आप निम्नलिखित में से किसी भी विकल्प के साथ आगे बढ़ सकते हैं।",
    "chatbox.customer.all.executives.busy.message":"हम प्रतीक्षा के लिए क्षमा चाहते हैं। हमारे सभी ग्राहक अधिकारी इस समय व्यस्त हैं। आप बाद में पुनः प्रयास कर सकते हैं या हमारे समर्थन को कॉल कर सकते हैं।",
    "chatbox.agent.end.chat.message": "हमसे संपर्क करने के लिए धन्यवाद! हमें उम्मीद है कि आपकी समस्या का समाधान हो गया है। यदि आपको और सहायता की आवश्यकता है, तो हम हमेशा यहाँ हैं।",
    "customer.alert.message": "हमारा प्रतिनिधि आपकी सहायता के लिए उपलब्ध और तैयार है। यदि इस समय आपको किसी और चीज़ की आवश्यकता नहीं है, तो कृपया बेझिझक चर्चा समाप्त करें।",
    "chatbox.department.non.working.day.msg":"हमसे संपर्क की पहल के लिए आपका धन्यवाद। कृपया ध्यान दें कि आज गैर-कार्य दिवस है और हमारी टीम इस समय आपकी सहायता के लिए उपलब्ध नहीं है। हम अगले कार्य दिवस पर यथाशीघ्र आपके प्रश्न का उत्तर देंगे। हम आपके धैर्य और समझ की सराहना करते हैं।",
    "chatbox.agent.out.of.office.msg" : "हमसे संपर्क करने के लिए धन्यवाद. हमारे काम के घंटे {{startTime}} से {{stopTime}} तक हैं। हमारी टीम फिलहाल दिन भर के लिए कार्यालय से बाहर है। कृपया अगले कार्य दिवस के दौरान बातचीत के लिए अनुरोध करें। हम आपके धैर्य और समझ की सराहना करते हैं।",
    "chatbox.rating.modal.heading": "चैटबोट अनुभव को रेट करें",
    "chatbox.rating.modal.message": "कृपया चैट बंद करने से पहले अपनी रेटिंग प्रदान करें।",
    "general.label.customerResponse.feedback": "ग्राहक प्रतिक्रिया दर्ज करें",
    "general.lable.customerResponse.text": "ग्राहक प्रतिक्रिया",
    "page.edit.escalation.button.label.bulkEdit": "थोक संपादित",
    "menu.key.report.area.of.concern": "चिंता का क्षेत्र रिपोर्ट",
    "general.tab.area.of.concern.type": "चिंता के क्षेत्र का प्रकार चुनें",
    "general.tab.area.of.concern.top.count": "शीर्ष गणना का चयन करें",
    "general.label.areaOfConcern": "चिंता का क्षेत्र",
    "menu.key.area.of.concern.report.id": "रिपोर्ट आईडी",
  "menu.key.area.of.concern.report.generated.by":"द्वारा उत्पन्न",
  "menu.key.area.of.concern.type":"चिंता का क्षेत्र",
  "menu.key.area.of.concern.date.of.generation": "उत्पत्ति की तिथि",
  "menu.key.area.of.concern.top.count" :"शीर्ष गिनती",
  "area.of.concern.issue.count" : "अंक संख्या",
  "area.of.concern.root.cause" : "मूल कारण",
  "area.of.concern.proposed.solution" : "प्रस्तावित समाधान",
  "area.of.concern.process.implemented" : "प्रक्रिया क्रियान्वित",
  "area.of.concern.target.closure.date" : "समापन तिथि",
  "area.of.concern.area.name" : "क्षेत्र",
  "area.of.concern.subarea.name" : "उपक्षेत्र",
  "area.of.concern.generate.success" : "रिपोर्ट सफलतापूर्वक तैयार की गई",
  "general.label.escalation.seletedAreas":"चयनित क्षेत्र/उपक्षेत्र",
  "bulk.resolve.feedbackCode.text": "फीडबैक कोड",
  "bulk.resolve.feedbackDescription.text": "प्रतिक्रिया विवरण",
  "menu.key.feedback.bulk.resolve": "थोक समाधान",
  "general.tab.area.of.concern.top.count.table": "टेबल के लिए टॉप काउंट चुनें",
  "general.tab.area.of.concern.top.count.visualization": "विज़ुअलाइज़ेशन के लिए टॉप काउंट चुनें",
  "alert.msg.department.attribute.fail": "कृपया सहेजने से पहले सभी अनिवार्य फ़ील्ड भरें!!",
  "menu.key.feedback.bulk.close": "थोक बंद",

    "chatbox": {
      "support": {
        "tollFreeNumber": "टोल-फ्री नंबर",
        "email": "ईमेल"
      }
    },
    "label.new.survey.mandatoryFieldValidation" : "सभी अनिवार्य फ़ील्ड भरे जाने चाहिए।",
    "label.survey.expired.message" : "सर्वेक्षण समाप्त हो गया है",
};